export var TrackingStatusCode;
(function (TrackingStatusCode) {
    TrackingStatusCode["preTransit"] = "pre_transit";
    TrackingStatusCode["inTransit"] = "in_transit";
    TrackingStatusCode["outForDelivery"] = "out_for_delivery";
    TrackingStatusCode["delivered"] = "delivered";
    // additional status codes
    TrackingStatusCode["availableForPickup"] = "available_for_pickup";
    TrackingStatusCode["returnToSender"] = "return_to_sender";
    TrackingStatusCode["failure"] = "failure";
    TrackingStatusCode["cancelled"] = "cancelled";
    TrackingStatusCode["unknown"] = "unknown";
    TrackingStatusCode["error"] = "error";
})(TrackingStatusCode || (TrackingStatusCode = {}));
export const trackingStatusCodeName = {
    [TrackingStatusCode.availableForPickup]: 'Available for Pickup',
    [TrackingStatusCode.cancelled]: 'Cancelled',
    [TrackingStatusCode.delivered]: 'Delivered',
    [TrackingStatusCode.error]: 'Error',
    [TrackingStatusCode.failure]: 'Failure',
    [TrackingStatusCode.inTransit]: 'In Transit',
    [TrackingStatusCode.outForDelivery]: 'Out for Delivery',
    [TrackingStatusCode.preTransit]: 'Pre-Transit',
    [TrackingStatusCode.returnToSender]: 'Return to Sender',
    [TrackingStatusCode.unknown]: 'Unknown',
};
export var TrackingStatusDetailCode;
(function (TrackingStatusDetailCode) {
    TrackingStatusDetailCode["unknown"] = "unknown";
    TrackingStatusDetailCode["return"] = "return";
    TrackingStatusDetailCode["statusUpdate"] = "status_update";
    TrackingStatusDetailCode["departedFacility"] = "departed_facility";
    TrackingStatusDetailCode["arrivedAtFacility"] = "arrived_at_facility";
    TrackingStatusDetailCode["outForDelivery"] = "out_for_delivery";
    TrackingStatusDetailCode["arrivedAtDestination"] = "arrived_at_destination";
    TrackingStatusDetailCode["label_created"] = "label_created";
    TrackingStatusDetailCode["in_transit"] = "in_transit";
    TrackingStatusDetailCode["received_at_destination_facility"] = "received_at_destination_facility";
    TrackingStatusDetailCode["delayed"] = "delayed";
    TrackingStatusDetailCode["received_at_origin_facility"] = "received_at_origin_facility";
    TrackingStatusDetailCode["delivery_exception"] = "delivery_exception";
    TrackingStatusDetailCode["arrived_at_pickup_location"] = "arrived_at_pickup_location";
    TrackingStatusDetailCode["transferred_to_destination_carrier"] = "transferred_to_destination_carrier";
    TrackingStatusDetailCode["departed_origin_facility"] = "departed_origin_facility";
    TrackingStatusDetailCode["held"] = "held";
})(TrackingStatusDetailCode || (TrackingStatusDetailCode = {}));
//# sourceMappingURL=tracking.js.map